/* eslint-disable import/prefer-default-export */
/**
 */
export const GIFT_CARD_TYPE = {
  BASIC: 'basic',
  E_GIFT_CARD: 'egiftcard',
  CONSOLIDATED_MASTER: 'consolidated_master',
};
